import { render, staticRenderFns } from "./delModal.vue?vue&type=template&id=480dc467&scoped=true"
import script from "./delModal.vue?vue&type=script&lang=js"
export * from "./delModal.vue?vue&type=script&lang=js"
import style0 from "./delModal.vue?vue&type=style&index=0&id=480dc467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480dc467",
  null
  
)

export default component.exports